import React from 'react';
import ActionCard from './ActionCard';

export default function CompassFeed({ cards, loading, fetchedAt }) {
  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner" />
        <div className="loading-text">Compass is analyzing your pipeline...</div>
      </div>
    );
  }

  const now = fetchedAt ? new Date(fetchedAt).toLocaleString() : '';

  return (
    <div className="feed-container">
      <div className="feed-header">
        <h2>What Needs Your Attention</h2>
        <p>Proactive guidance ordered by urgency {now && `\u2022 Data as of ${now}`}</p>
      </div>
      {cards.length === 0 ? (
        <div className="action-card">
          <div className="card-header">
            <h3>No action items generated</h3>
          </div>
          <div className="card-summary">
            This could mean integrations aren't connected yet, or the analysis engine needs API keys configured.
            Check your .env file and ensure ANTHROPIC_API_KEY, Google OAuth, and n8n API key are set.
          </div>
        </div>
      ) : (
        cards.map((card, i) => <ActionCard key={card.id || i} card={card} />)
      )}
    </div>
  );
}
